import Blazy from "./../_lib/lazyLoad/blazy.min.js";
import "./mainNavigation";
import "./carousel";
import "./../_lib/owlCarousel/dist/owl.carousel.js";
import "./../_lib/fancybox/jquery.fancybox.min.js";
import "./countdown";
import "./focusText";
import "./textaccordion";
import "./agenda";
import "./dateToString";
import "./input";
import "./tabFocus";
import "./tables";
import "./subscriptions";
import TaxonomyDropdown from "./TaxonomyDropdown";
import "./../_lib/niceSelect/niceSelect";
import TaxonomyList from "./TaxonomyList";
import ContactPeopleTaxonomyList from "./ContactPeopleTaxonomyList";
import "./LinkDropdown";
import "./videobackground.js";
import "./cookieconsent.js";
import "./smoothScroll.js";
import "./wffmManipulation.js";
import "./video";
import "./banner";
import "./news";
import "./postings";
import "./searchPostings";

document.addEventListener("DOMContentLoaded", () => {
    window.bLazy = new Blazy({
        offset: 200,
        breakpoints: [
            {
                width: 480, // max-width
                src: "data-src-xs"
            },
            {
                width: 667, // max-width
                src: "data-src-sm"
            },
            {
                width: 1024, // max-width
                src: "data-src-md"
            },
            {
                width: 1366, // max-width
                src: "data-src-lg"
            }
        ]
    });

    TaxonomyDropdown.init();
    TaxonomyList.init(".module-taxonomy-list .item-list[data-source-id]");
    TaxonomyList.init(".event-list .item-list[data-source-id]");
    TaxonomyList.init(".news-overview .item-list[data-source-id]");
    ContactPeopleTaxonomyList.init(".module-contactpeople-default .item-list");

    if (!navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)) {
        if (document.querySelector('.module-form-apsis-js') != null) {
            window.setTimeout(function () {
                $("select:not([multiple])").not("[class*='flatpickr']").niceSelect(null, function ($dropdown) {
                    checkForDropUp($dropdown);

                    $(window).scroll(function() {
                        if ($dropdown.hasClass("open")) {
                            checkForDropUp($dropdown);
                        }
                    });
                });
            }, 2000);
        } else {
            $("select:not([multiple])").not("[class*='flatpickr']").niceSelect(null, function ($dropdown) {
                checkForDropUp($dropdown);

                $(window).scroll(function() {
                    if ($dropdown.hasClass("open")) {
                        checkForDropUp($dropdown);
                    }
                });
            });
        }
    }
});

function checkForDropUp(triggeredSelect) {
    // // Get Top position and height of niceselect container respective to window
    var dropdownContainer = $(triggeredSelect);
    var position = jQuery(dropdownContainer)[0].getBoundingClientRect().top;
    var buttonHeight = jQuery(dropdownContainer)[0].getBoundingClientRect()
        .height;

    // Get height of niceselect doprdown (ul)
    // As Dropdown element is hidden so we cloned the dropdown to get the height, and remove that
    // cloned element after getting the height
    var dropdownMenu = dropdownContainer.find("ul.list");
    var style = "position: absolute !important; top: -10000000 !important;";
    var dropdownMenuClone = dropdownMenu
        .clone()
        .attr("style", style)
        .appendTo("body");
    var menuHeight = dropdownMenuClone.outerHeight(true);
    dropdownMenuClone.remove();

    var $win = jQuery(window);

    if (
        position > menuHeight &&
        $win.height() - position < buttonHeight + menuHeight
    ) {
        dropdownContainer.addClass("dropup-container");
        dropdownMenu.addClass("dropup");
    } else {
        dropdownContainer.removeClass("dropup-container");
        dropdownMenu.removeClass("dropup");
    }
}
